<template>
  <!-- 物流包装 -->
  <div class="Minister-top information">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">物流包装</div>
    </div>
    <div class="information_content">
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          商品状态
        </div>
        <div class="input_el input_span">
          <el-select
            style="width: 260px"
            v-model="formData.shopStatus"
            placeholder="请选择店铺后再选择店铺"
            :disabled="system < 5 || isChakan"
            filterable>
            <el-option
              v-for="item in goodsStatusOtions"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          发货天数
        </div>
        <div class="input_el input_span">
          <div class="input_bot_tip">
            <el-select
              v-if="daysList.length"
              style="width: 260px"
              v-model="formData.day"
              :disabled="system < 5 || isChakan"
              filterable>
              <el-option
                v-for="item in daysList"
                :key="item"
                :label="item"
                :value="item"></el-option>
            </el-select>
            <el-input
              v-else
              v-model="formData.day"
              style="width: 260px"
              class="danwei_input"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              :disabled="system < 5 || isChakan"></el-input>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          重量
        </div>
        <div class="input_el input_span">
          <div class="input_bot_tip">
            <el-input
              v-model="formData.weight"
              style="width: 260px"
              class="danwei_input"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              :disabled="system < 5 || isChakan">
              <el-select
                slot="append"
                v-model="formData.weightUnit"
                placeholder="请选择"
                :disabled="system < 5 || isChakan"
                filterable>
                <el-option
                  v-for="item in danweiOtions"
                  :key="item.company_id"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-input>
            <span>重量尺寸影响全球发布时的价格自动计算，请填写准确数据</span>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom: 20px">
        <div class="information_Title">
          <span class="tips">*</span>
          包裹尺寸
        </div>
        <div class="input_el input_span">
          <div class="input_changkuangao">
            <el-input
              v-model="formData.width"
              style="width: 260px"
              class="danwei_input"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              :disabled="system < 5 || isChakan"
              placeholder="宽">
              <el-select
                slot="append"
                v-model="formData.dimensionUnit"
                placeholder="请选择"
                filterable>
                <el-option
                  v-for="item in changOtions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-input>
            <el-input
              v-model="formData.height"
              style="width: 260px; margin-left: 15px"
              class="danwei_input"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              :disabled="system < 5 || isChakan"
              placeholder="高">
              <el-select
                slot="append"
                v-model="formData.dimensionUnit"
                placeholder="请选择"
                filterable>
                <el-option
                  v-for="item in changOtions"
                  :key="item.company_id"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-input>
            <el-input
              v-model="formData.depth"
              style="width: 260px; margin-left: 15px"
              class="danwei_input"
              oninput="value=value.replace(/[^0-9.]/g,'')"
              :disabled="system < 5 || isChakan"
              placeholder="长">
              <el-select
                slot="append"
                v-model="formData.dimensionUnit"
                placeholder="请选择"
                filterable>
                <el-option
                  v-for="item in changOtions"
                  :key="item.company_id"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'wuliuComp',
  props: {
    score: {
      type: Array,
      default() {
        return [0, 0, 0, 0]
      }
    }
  },
  data() {
    return {
      //是否为查看
      isChakan: false,
      system: 5,
      formData: {
        // 商品状态
        shopStatus: '',
        day: '',
        weight: undefined,
        weightUnit: 'g',
        width: undefined,
        height: undefined,
        depth: undefined,
        dimensionUnit: 'cm',
        danwei: 'g'
      },

      daysList: [],
      goodsStatusOtions: [
        { label: '全新', value: 'NEW' },
        { label: '二手', value: 'USED' }
      ],
      zengzhiOtions: [
        { label: '无', value: '0' },
        { label: '10%', value: '0.1' },
        { label: '20%', value: '0.2' }
      ],
      danweiOtions: [
        { label: '克', value: 'g' },
        { label: '公斤', value: 'kg' },
        { label: '磅', value: 'lb' }
      ],
      changOtions: [
        { label: '毫米', value: 'mm' },
        { label: '厘米', value: 'cm' },
        { label: '英寸', value: 'in' }
      ]
    }
  },
  created() {
    this.system = JSON.parse(localStorage.getItem('role')).system
  },
  methods: {
    async fetchDayInfo(id) {
      try {
        const url =
          Baseurl + `shopeeCategoryController/selectCategoryByCategoryId`
        const payload = {
          categoryId: id
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.daysList = data.daysToShipRangeList
        }
      } catch (error) {
        console.log(error)
      }
    },
    setFormData(data) {
      this.formData.shopStatus = data.shopStatus
      this.formData.day = data.day
      this.formData.weight = data.weight
      this.formData.width = data.width
      this.formData.height = data.height
      this.formData.depth = data.depth
    },
    getFormData() {
      return JSON.parse(JSON.stringify(this.formData))
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../shopee.less';
.input_bot_tip {
  display: flex;
  align-items: center;
  // flex-direction: column;
}
.input_changkuangao {
  display: flex;
}
.danwei_input {
  /deep/ .el-input-group__append {
    width: 60px !important;
  }
}
</style>
